/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskModuleTypeEnum } from './TaskModuleTypeEnum';
import {
    TaskModuleTypeEnumFromJSON,
    TaskModuleTypeEnumFromJSONTyped,
    TaskModuleTypeEnumToJSON,
    TaskModuleTypeEnumToJSONTyped,
} from './TaskModuleTypeEnum';
import type { TaskChannelTypeEnum } from './TaskChannelTypeEnum';
import {
    TaskChannelTypeEnumFromJSON,
    TaskChannelTypeEnumFromJSONTyped,
    TaskChannelTypeEnumToJSON,
    TaskChannelTypeEnumToJSONTyped,
} from './TaskChannelTypeEnum';

/**
 * Response light for get task box
 * @export
 * @interface TaskBoxLightResponse
 */
export interface TaskBoxLightResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskBoxLightResponse
     */
    id?: string;
    /**
     * The task box name
     * @type {string}
     * @memberof TaskBoxLightResponse
     */
    title?: string;
    /**
     * 
     * @type {TaskModuleTypeEnum}
     * @memberof TaskBoxLightResponse
     */
    moduleType?: TaskModuleTypeEnum;
    /**
     * 
     * @type {TaskChannelTypeEnum}
     * @memberof TaskBoxLightResponse
     */
    channelType?: TaskChannelTypeEnum;
}



/**
 * Check if a given object implements the TaskBoxLightResponse interface.
 */
export function instanceOfTaskBoxLightResponse(value: object): value is TaskBoxLightResponse {
    return true;
}

export function TaskBoxLightResponseFromJSON(json: any): TaskBoxLightResponse {
    return TaskBoxLightResponseFromJSONTyped(json, false);
}

export function TaskBoxLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskBoxLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'moduleType': json['moduleType'] == null ? undefined : TaskModuleTypeEnumFromJSON(json['moduleType']),
        'channelType': json['channelType'] == null ? undefined : TaskChannelTypeEnumFromJSON(json['channelType']),
    };
}

export function TaskBoxLightResponseToJSON(json: any): TaskBoxLightResponse {
    return TaskBoxLightResponseToJSONTyped(json, false);
}

export function TaskBoxLightResponseToJSONTyped(value?: TaskBoxLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'moduleType': TaskModuleTypeEnumToJSON(value['moduleType']),
        'channelType': TaskChannelTypeEnumToJSON(value['channelType']),
    };
}

